import appBasicplans from "../../views/appPlans/basics.html";
import constants from "../../core/constants";
import { getState } from "../../core/utils";

function urlsConfig($stateProvider) {
  "ngInject";

  const base = "basicplans";
  const params = ["page", "limit"];

  $stateProvider.state("basicplans", {
    url: getState(base, params),
    parent: "app",
    views: {
      view: {
        template: appBasicplans,
      },
    },
    reloadOnSearch: false,
    data: { title: "Basicplans" + constants.titleBase },
  });
}

export default urlsConfig;



// WEBPACK FOOTER //
// ./src/pages/basicplans/basicplans.urls.js